<template>
  <a class="location" :href="link" target="_blank" :title="label">
    <Icon id="marker" class="location__icon" />
    <span>{{ label }}</span>
  </a>
</template>

<script>
import { Icon } from '@/components/global'

export default {
  name: 'Location',
  components: { Icon },
  props: {
    label: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
}
</script>
